import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import AdminPanel from './components/AdminPanel';
import { API_URL } from './config';

function App() {
  const [adminLoggedIn, setAdminLoggedIn] = useState(false);
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });

  // Check URL for /admin path
  useEffect(() => {
    if (window.location.pathname === '/admin' || window.location.pathname === '/admin/') {
      setShowAdminLogin(true);
    }
  }, []);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(`${API_URL}?action=login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginData)
      });
      
      const data = await response.json();
      
      if (data.success) {
        setAdminLoggedIn(true);
        setShowAdminLogin(false);
        setLoginData({ username: '', password: '' });
      } else {
        alert('Kullanıcı adı veya şifre hatalı!');
      }
    } catch (error) {
      alert('Giriş sırasında hata oluştu');
      console.error(error);
    }
  };

  const handleAdminLogout = () => {
    setAdminLoggedIn(false);
  };

  // Admin Panel Görünümü
  if (adminLoggedIn) {
    return (
      <div className="App">
        <AdminPanel onLogout={handleAdminLogout} />
      </div>
    );
  }

  // Admin Giriş Formu
  if (showAdminLogin) {
    return (
      <div className="App admin-login-page">
        <div className="admin-login-container">
          <div className="login-card">
            <h1>🍖 Resume Çiğköfte Admin</h1>
            <p>Admin paneline giriş yapın</p>
            
            <form onSubmit={handleAdminLogin}>
              <input
                type="text"
                name="username"
                placeholder="Kullanıcı Adı"
                value={loginData.username}
                onChange={handleLoginChange}
                required
              />
              <input
                type="password"
                name="password"
                placeholder="Şifre"
                value={loginData.password}
                onChange={handleLoginChange}
                required
              />
              <button type="submit" className="login-btn">Giriş Yap</button>
            </form>
            
            <button 
              className="back-btn"
              onClick={() => {
                setShowAdminLogin(false);
                window.history.pushState({}, '', '/');
              }}
            >
              Ana Sayfaya Dön
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Normal Anasayfa
  return (
    <div className="App">
      <Header />
      <Hero />
      <Products />
      <About />
      <Contact />
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
